var React = require('react');

function MoreIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27 16.5C27 22.299 22.299 27 16.5 27S6 22.299 6 16.5 10.701 6 16.5 6 27 10.701 27 16.5zm2 0C29 23.404 23.404 29 16.5 29S4 23.404 4 16.5 9.596 4 16.5 4 29 9.596 29 16.5zM11.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm3.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z","fill":"#fff"}));
}

MoreIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = MoreIcon;

MoreIcon.default = MoreIcon;
